import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { SearchGrid } from '@app/components/blocks/searchGrid/SearchGrid'
import { Variant } from '@app/components/core/tag/Tag'
import { AddressModel, labelAddressBuilder } from '@app/util/helpers'
import { useTranslations } from '@i18n/useLanguage'

type InitiativeSearchGridItem = {
  id: string
  slug?: string
  image: string
  title: string
  description?: string
  address: AddressModel
  phase?: string
  tagText: string
  tagVariant: Variant
  isSpotlight?: boolean
}

export type InitiativeSearchGridProps = {
  items: InitiativeSearchGridItem[]
  totalItems: number
  title: string
  subtitle: string
  searchTerm?: string
  isLoading: boolean
  loadMore: () => void
  onResetSearch: () => void
  onNavigate: (key: string) => void
}

export const InitiativeSearchGrid = (props: InitiativeSearchGridProps) => {
  const notSpecified = useTranslations().app.common.notSpecified
  return (
    <SearchGrid
      {...props}
      items={props.items.map((i) =>
        renderCard(i, () => props.onNavigate(i.id), notSpecified),
      )}
      gridStyle={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(250px, 1fr))',
        '@media (max-width: 1200px)': {
          gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
        },
        gap: '1.5rem',
      }}
    />
  )
}

const renderCard = (
  item: InitiativeSearchGridItem,
  onClick: VoidFunction,
  notSpecified: string,
) => {
  const { address, ...rest } = item
  return (
    <InitiativeCard
      key={item.id}
      variant={item.isSpotlight ? 'spotlight' : 'default'}
      onClick={onClick}
      {...rest}
      location={labelAddressBuilder(address, notSpecified) ?? notSpecified}
      description={undefined}
    />
  )
}
